import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Header, Button, Icon, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

function PageNotFound() {
  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - Page Not Found</title>
      </Helmet>

      <Container>
        <Segment vertical textAlign="center" style={{ marginTop: '5em' }}>
          <Header as="h1" icon>
            <Icon name="search" />
            404 - Page Not Found
            <Header.Subheader>
              The page you're looking for doesn't exist or has been moved.
            </Header.Subheader>
          </Header>

          <Button as={Link} to="/" primary size="large">
            <Icon name="home" /> Go to Homepage
          </Button>
        </Segment>
      </Container>
    </>
  );
}

export default PageNotFound; 